'use client';

import { BasicModal, TextButton } from 'components';
import { Row } from 'styles';
import { useFetchTerms } from '../modules';

interface TermsModalProps {
  open: boolean;
  onClose: () => void;
}

export const TermsModal: React.FC<TermsModalProps> = ({ open, onClose }) => {
  const { data: terms } = useFetchTerms();

  if (!terms) {
    return <div></div>;
  }

  return (
    <BasicModal
      header="Terms of Service"
      width={900}
      height={500}
      open={open}
      onClose={onClose}
      body={<div dangerouslySetInnerHTML={{ __html: terms }} />}
      footer={
        <Row>
          <TextButton label={'OK'} onClick={onClose} />
        </Row>
      }
    />
  );
};
